// Public Google Calendar booking page for a Discovery Session (owned by
// discovery@sahod.solutions). One real calendar serves every environment, so UAT
// test bookings land in it too — cancel them after testing. See
// PRD/PRD_DiscoverySession.md C11.
export const DISCOVERY_BOOKING_URL = "https://calendar.app.google/pFyZgw1r9fsXcC1MA";
